import React from 'react';
import PropTypes from 'prop-types';

import { InputGroup, InputGroupAddon, InputGroupText, Button } from 'reactstrap';

import { CurrentTheme, MagstimDropdown } from "common";
import MagstimInputGroup from './MagstimInputGroup'

class MagstimInputGroupDropDownWithButton extends MagstimInputGroup {

    render() {

        return(
            <InputGroup size={CurrentTheme().ControlSize}>
            <InputGroupAddon addonType="prepend">
                <InputGroupText>{this.props.title}</InputGroupText>
            </InputGroupAddon>

            <MagstimDropdown size={CurrentTheme().ControlSize} ref={this.props.dropDownRef} disabled={this.props.disabled}>
                {this.props.options.map(option => (
                    this.dropdownItem(option, this.props.default)
                ))}
            </MagstimDropdown>

            <InputGroupAddon addonType="prepend">
                <Button color="primary" size={CurrentTheme().ControlSize} onClick={this.props.onClick}><i className="fas fa-times"></i></Button>
            </InputGroupAddon>

            </InputGroup>

        );
    }
}

MagstimInputGroupDropDownWithButton.propTypes = {
    title: PropTypes.string,
    options:PropTypes.array,
    default:PropTypes.string,
    dropDownRef:PropTypes.object,
    disabled:PropTypes.bool,
    onClick:PropTypes.func
};

MagstimInputGroupDropDownWithButton.defaultProps = {
    title: "",
    options:[],
    default:"",
    dropDownRef:undefined,
    disabled:false,
    onClick:undefined
};

export default MagstimInputGroupDropDownWithButton